// ----------------------------------------------------------------------

export function remToPx(value: string): number {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number): string {
  return `${value / 16}rem`;
}

type ResponsiveSizes = {
  sm: number;
  md: number;
  lg: number;
};

/** Breakpoint-scaled font sizes, matching the original theme's media queries. */
export function responsiveFontSizes({ sm, md, lg }: ResponsiveSizes) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}
